import { MatrizEvaluacionAdmin } from '@/components/MatrizEvaluacionAdmin';
import { Button, LoadingContainer } from '@/components/ui';
import { useEvaluacionAdmin } from '@/hooks';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

export function DashboardAsesoriaMatrizPage() {
  const { nit, asesoriaId } = useParams<{ nit: string; asesoriaId: string }>();
  const navigate = useNavigate();

  const asesoriaIdParsed = asesoriaId ? parseInt(asesoriaId, 10) : null;
  const { data: evalResponse, isLoading, error } = useEvaluacionAdmin(asesoriaIdParsed);

  return (
    <div className="w-screen h-screen p-4 sm:p-6 bg-gray-50 flex flex-col overflow-hidden">
      <div className="flex items-center gap-4 shrink-0 mb-4">
        <Button variant="ghost" onClick={() => navigate(-1)} className="p-2 bg-white shadow-sm border border-gray-200">
          <ArrowLeft className="w-5 h-5" />
          <span className="ml-2">Volver</span>
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Matriz de Evaluación en Vivo</h1>
          <p className="text-sm text-gray-500">Asesoría seleccionada #{asesoriaId}</p>
        </div>
      </div>

      <div className="flex-1 min-w-0 overflow-hidden flex flex-col">
        {isLoading && <LoadingContainer text="Cargando matriz de evaluación..." />}
        {error && <p className="text-red-600 p-8 text-center">{error}</p>}
        {!isLoading && !error && evalResponse && (
          <MatrizEvaluacionAdmin
            data={evalResponse}
            className="flex-1 min-h-0 min-w-0 bg-white shadow-sm border border-gray-200 rounded-lg p-4 sm:p-6"
          />
        )}
      </div>
    </div>
  );
}
